import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import setFilterQuery from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";

type HandlerType = HandlerWithResult<ProductFilters, ProductFilters>;

export const MergeParameter: HandlerType = props => {
    const currentFilters = cloneDeep(props.getState().pages.productList.productFilters);
    props.result = merge(currentFilters, props.parameter);
};

export const DispatchSetProductFilters: HandlerType = props => {
    props.dispatch({
        type: "Pages/ProductList/SetProductFilters",
        result: props.result,
    });
};

export const DispatchSetFilterQuery: HandlerType = props => {
    props.dispatch(setFilterQuery());
};

export const chain = [
    MergeParameter,
    DispatchSetProductFilters,
    DispatchSetFilterQuery,
];

const loadSelectedProductFilters = createHandlerChainRunner(chain, "loadSelectedProductFilters");
export default loadSelectedProductFilters;